import API from '@/api'

export default {
  namespaced: true,
  state: {
    loading: true,
    data: {
      all: [],
      selected: [],
      backup: []
    },
    pageCount: 0,
    filter: {
      type: 'all',
      search: '',
      page: '0',
      take: '50',
    },
    typeAlias: {
      '1': 'SOLID',
      '2': 'SOLID',
      '5': 'SOLID',
      '3': 'Acid',
      '4': 'Liquid',
      '6': 'Liquid',
    },
    nutrients: ['B', 'Fe', 'Mn', 'Zn', 'Cu', 'Mo', 'NO3', 'NH4', 'NH2', 'P', 'K', 'Ca', 'Mg', 'S', 'CO3', 'HCO3', 'Cl', 'Na'],
    flag: 'programm',
    programId: false,
    query: false
  },
  mutations: {
    saveData (state, data) {
      var new_arr = data.map(function (item) {
        var result = {};

        var nutrients = item.data.Fertilizer.ElementsConcentration;

        for (var key in nutrients) {
          // /_Val$/ не уверен
          var regTemplate = /(\w+)_Val/;
          var regArray = regTemplate.exec(key);

          if (regArray && state.nutrients.indexOf(regArray[1]) != -1 && Number(nutrients[key]) > 0) {
            result[regArray[1]] = Number(nutrients[key]);
          }
        }

        var add = false;
        var percent = false;
        for (var i in state.data.selected) {
          if (state.data.selected[i].id == item.id) {
            add = true;
            percent = state.data.selected[i].acidPercentage;
          }
        }
        let costUnit = (state.typeAlias[item.stateId] == 'SOLID') ? 'kg' : 'L';
        return {
          id: item.id,
          name: item.name,
          type: state.typeAlias[item.stateId],
          nutrients: result,
          add: add,
          percent: percent,
          cost: item.cost,
          costUnit: costUnit,
          // new ??
          density: Number(item.data.Fertilizer['SpecificWeight'])
        };
      });

      state.data.all = new_arr;
    },
    savePageCount (state, pages) {
      if (state.data.all.length > 0) {
        state.pageCount = pages;
      } else {
        state.pageCount = 0;
      }

    },
    savePage (state, page) {
      console.log(page);
      state.filter.page = page;
    },
    saveSearch (state, value) {
      state.filter.search = value;
    },
    loading(state, bool) {
      state.loading = bool;
    },
    addFertilizer (state, id) {
      for (var i in state.data.all) {
        if (state.data.all[i].id == id) {
          state.data.all[i].add = true;
          state.data.all[i].percent = 0;

          state.data.selected.push(state.data.all[i]);
        }
      }
    },
    removeFertilizer (state, id) {
      for (var i in state.data.selected) {
        if (state.data.selected[i].id == id) {
          state.data.selected[i].add = false;
          state.data.selected[i].percent = 0;

          var flag = false;
          for (var j in state.data.all) {
            if (state.data.all[j].id == id) {
              state.data.all[j].add = false;
              state.data.all[j].percent = 0;
              flag = true;
            }
          }

          if (!flag) {
            state.data.all.push(state.data.selected[i]);
          }
          state.data.selected.splice(i, 1);
        }
      }
    },
    updatePercent (state, obj) {
      for (var i in state.data.selected) {
        if (state.data.selected[i].id == obj.id) {
          state.data.selected[i].percent = obj.percent;
        }
      }
    },
    updateCost(state, obj) {
      for (var i in state.data.selected) {
        if (state.data.selected[i].id == obj.id) {
          state.data.selected[i].cost = obj.cost;
        }
      }
    },
    setProgramId (state, programId) {
      state.programId = programId;
    },
    setFlag (state, flag) {
      state.flag = flag;
      state.data = {all: [], selected: [], backup: []};
    },
    clearSelectedFertilizers(state) {
      state.data.selected = [];
    },
    selectFertilizers (state, data) {
      var new_arr = data.map(function (item) {
        var result = {};

        var nutrients = item.fertilizer.data.Fertilizer.ElementsConcentrations;

        for (var key in nutrients) {
          var regTemplate = /(\w+)_Val/;
          var regArray = regTemplate.exec(key);

          if (regArray && state.nutrients.indexOf(regArray[1]) != -1) {
            result[regArray[1]] = Number(nutrients[key]);
          }
        }

        let costUnit = ( state.typeAlias[item.fertilizer.stateId] == 'SOLID' ) ? 'kg' : 'L';
        return {
          id: item.fertilizerId,
          name: item.fertilizer.name,
          type: state.typeAlias[item.fertilizer.stateId],
          nutrients: result,
          add: true,
          cost: item.fertilizer.cost,
          costUnit: item.fertilizer.unit ? item.fertilizer.unit : costUnit,
          percent: item.acidPercentage,
          density: Number(item.fertilizer.data.Fertilizer['SpecificWeight']),
          translations: item.fertilizer.translations,
        };
      });

      state.data.selected = new_arr.slice();
      state.data.backup = new_arr.slice();
    },
  },
  actions: {
    destroyState({ state, commit }) {
        state.data = {
          all: [],
          selected: [],
          backup: []
        };
        state.pageCount = 0;
        state.filter = {
          type: 'all',
          search: '',
          page: '0',
          take: '50',
        };
        state.typeAlias = {
          '1': 'SOLID',
          '2': 'SOLID',
          '5': 'SOLID',
          '3': 'Acid',
          '4': 'Liquid',
          '6': 'Liquid',
        };
        state.nutrients = ['B', 'Fe', 'Mn', 'Zn', 'Cu', 'Mo', 'NO3', 'NH4', 'NH2', 'P', 'K', 'Ca', 'Mg', 'S', 'CO3', 'HCO3', 'Cl', 'Na'];
        state.flag = 'programm';
        state.programId = false;
        state.query = false;
    },

    getFertilizers ({ commit, state }) {
      commit('loading', true);
      var data = {
        page: state.filter.page,
        take: state.filter.take,
        type: state.filter.type,
        search: (state.filter.search ? state.filter.search : undefined),
      };

      // getFertilizersForBaseDressing

      if (state.flag == 'programm') {
        return API.fertilizers.getFertilizers(data).then(res => {
          commit('saveData', res.data.data.data);
          commit('savePageCount', res.data.data.pages);
          commit('loading', false);
        });
      } else {
        return API.fertilizers.getFertilizersForBaseDressing(data).then(res => {
          commit('saveData', res.data.data.data);
          commit('savePageCount', res.data.data.pages);
          commit('loading', false);
        });
      }

    },
    getSelectedFertilizers ({ commit, state }) {
      var data = {programId: state.programId};

      if (state.flag == 'programm') {
        return API.fertilizers.getSelectedFertilizersProgram(data).then(res => {
          commit('selectFertilizers', res.data.data);
        });
      } else {
        return API.fertilizers.getSelectedFertilizersDressing(data).then(res => {
          commit('selectFertilizers', res.data.data);
        });
      }
    },
    async updateSelected ({ state, dispatch }) {
      var error = false;
      var create = state.data.selected.map(function (item) {
        var res = {fertilizerId: item.id};
        if (item.type == 'Acid') {
          if (item.percent > 0) {
            res.acidPercentage = item.percent;
          } else {
            error = 'Please, enter percent in acid fertilizer';
          }
        }
        return res;
      });

      if (!error) {
        await dispatch('setFertilizers', create);
      }
      return {error};
    },
    setFertilizers ({ commit, state }, data) {
      var result = {data, programId: state.programId};
      // console.log(result.data);
      if(result.data.length <= 0) {

        // console.log('empty');

        state.query = true;
        if (state.flag == 'programm') {
          return API.fertilizers.dropScheduleFertilizers(result).then(res => {
            state.query = false;
          });
        } else {
          return API.fertilizers.dropBaseDressingFertilizers(result).then(res => {
            state.query = false;
            commit('clearSelectedFertilizers');
          });
        }

      } else {

        state.query = true;
        if (state.flag == 'programm') {
          return API.fertilizers.setFertilizersProgram(result).then(res => {
            state.query = false;
          });
        } else {
          return API.fertilizers.setFertilizersDressing(result).then(res => {
            state.query = false;
          });
        }

      }


    },

  },
  getters: {
    loading(state) {
      return state.loading;
    },
    getFertilizersAll (state) {
      return state.data.all;
    },
    getPage (state) {
      return state.filter.page;
    },
    getPageCount (state) {
      return state.pageCount;
    },
    getSelected (state) {
      return state.data.selected;
    },
    getNotSelected (state) {
      return state.data.all.filter(function (item) {
        if (!item.add) {
          if (state.filter.search && state.filter.search != '') {
            if (item.name.toLowerCase().indexOf(state.filter.search.toLowerCase()) != -1) {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        } else {
          return false;
        }
      });
    },
    getQuery (state) {
      return state.query;
    }
  }
}
